module.exports = __webpack_public_path__ + "img/TSN_06.9e61ba80.png";